export default {
  common: {
    loading: "Chargement",
    error: "Erreur",
    noData: "Aucune donnée disponible",
    back: "Retour",
  },
  nav: {
    historicalStats: "Statistiques historiques",
    liveView: "Vue en direct",
    settings: "Paramètres",
    logout: "Déconnexion",
  },
  auth: {
    login: "Connexion",
    username: "Nom d'utilisateur",
    password: "Mot de passe",
    usernamePlaceholder: "Entrez votre nom d'utilisateur",
    passwordPlaceholder: "Entrez votre mot de passe",
    usernameRequired: "Le nom d'utilisateur est requis",
    passwordRequired: "Le mot de passe est requis",
    unexpectedError: "Une erreur inattendue s'est produite",
  },
  projects: {
    title: "Projets",
    loading: "Chargement de vos projets...",
    failedToLoad: "Échec du chargement des projets",
    noProjectsYet: "Aucun projet pour le moment",
    noProjectsDesc: "Vous n'avez été assigné à aucun projet",
    viewProject: "Voir le projet",
    role: {
      admin: "Admin",
      member: "Membre",
    },
    eventCount: "aucun événement | 1 événement | {count} événements",
  },
  events: {
    title: "Événements",
    backToProjects: "Retour aux projets",
    failedToLoad: "Échec du chargement des événements",
    noEventsYet: "Aucun événement pour le moment",
    noEventsDesc: "Ce projet n'a aucun événement",
    viewEvent: "Voir l'événement",
    created: "Créé le {date}",
    status: {
      upcoming: "À venir",
      live: "En direct",
      ended: "Terminé",
    },
  },
  filters: {
    cameras: "Caméras",
    date: "Date",
    dateRange: "Plage de dates",
    class: "Classe",
    granularity: "Granularité",
    allCameras: "Toutes les caméras",
    selectDate: "Sélectionner une date",
    selectDateRange: "Sélectionner la plage de dates",
    selectClass: "Sélectionner la classe",
    selectGranularity: "Sélectionner la granularité",
    camsSelected: "aucune caméra sélectionnée | 1 caméra sélectionnée | {count} caméras sélectionnées",
    sectors: "Secteurs",
    allSectors: "Tous les secteurs",
    sectorsSelected: "aucun secteur sélectionné | 1 secteur sélectionné | {count} secteurs sélectionnés",
    granularityOptions: {
      minute: "Minute",
      hour: "Heure",
      day: "Jour",
    },
    classNames: {
      person: "Personne",
      car: "Voiture",
      truck: "Camion",
      bus: "Bus",
      bicycle: "Vélo",
      motorcycle: "Moto",
      boat: "Bateau",
      all: "Toutes les classes",
    },
    zone: "Zone",
    allZones: "Toutes les zones",
    detail: "Détail",
    allDetails: "Tous les détails",
    groupBy: "Grouper par",
    groupByOptions: {
      camera: "Caméra",
      zone: "Zone",
      detail: "Détail",
    },
  },
  stats: {
    title: "Statistiques historiques",
    loading: "Chargement",
    loadingDesc: "Chargement des données de l'API...",
    failedToLoad: "Échec du chargement des données",
    failedToLoadDesc: "Échec de l'obtention des données de détection",
    noDataAvailable: "Aucune donnée disponible",
    noDataDesc: "Aucune donnée de détection trouvée pour les filtres sélectionnés",
    initializing: "Initialisation du tableau de bord...",
    detectionsPerSector: "Détections par secteur",
    warnThreshold: "Alerte",
    alertThreshold: "Critique",
    perMinute: "par minute",
    densityUnit: "par m²",
    directionUnit: "passages",
  },
  schedules: {
    title: "Calendriers des caméras de l'événement",
    loading: "Chargement des calendriers...",
    failedToLoad: "Échec du chargement des calendriers",
    noSchedules: "Aucun calendrier assigné à cet événement",
    table: {
      scheduleName: "Nom du calendrier",
      camera: "Caméra",
      startTime: "Heure de début",
      endTime: "Heure de fin",
      duration: "Durée",
      status: "Statut",
    },
  },
  live: {
    title: "Vue en direct",
    eventNotFound: "Événement introuvable",
    eventNotFoundDesc: "L'événement demandé est introuvable",
    eventLive: "L'événement est actuellement en direct",
    eventEnded: "L'événement est terminé",
    eventEndedDesc: "Cet événement s'est terminé le {date}",
    noCameras: "Aucune caméra assignée à cet événement",
    waitingForData: "En attente des données de la caméra...",
    loading: "Chargement des statistiques en direct...",
    sector: "Secteur",
    dayOfEvent: "Jour {current} sur {total}",
    badges: {
      live: "En direct",
      recent: "Récent",
    },
    updatedAgo: "Mis à jour il y a {seconds}s",
    camsAllOnline: "toutes en ligne",
    camsAllOffline: "toutes hors-ligne",
    camsSomeOffline: "{count} hors-ligne",
    camsNone: "aucune cam",
    activeMap: "Carte active",
    camCount: "aucune cam | 1 cam | {count} cams",
    online: "en ligne",
    offline: "hors-ligne",
    staleTag: "obsolète",
    lastUpdate: "Dernière màj il y a {time}",
    densityValue: {
      alert: "ALERTE",
      warning: "AVIS",
      ok: "OK",
    },
    sectorStatus: {
      noData: "AUCUNE DONNÉE",
      incomplete: "INCOMPLET",
      stale: "OBSOLÈTE",
      partlyStale: "PART. OBSOL.",
      alert: "ALERTE",
      warning: "AVIS",
      normal: "OK",
    },
    zoneTable: {
      zone: "Zone",
      cam: "Cam",
      class: "Classe",
      count: "N",
      area: "m²",
      density: "D",
      noData: "aucune donnée",
      updated: "MàJ",
    },
    statusText: {
      alert: "alerte",
      warning: "avert.",
      normal: "ok",
    },
    configTable: {
      zone: "Zone",
      cam: "Cam",
      class: "Classe",
      area: "Aire",
      minAngle: "∠ Min",
      maxAngle: "∠ Max",
      warn: "Avert. ≥",
      alert: "Alerte ≥",
    },
    camTable: {
      camera: "Caméra",
      status: "Statut",
      lastSeen: "Dernière vue",
      startEnd: "Début / Fin",
    },
    alertStrip: {
      alert: "{n} secteur en alerte : | {n} secteurs en alerte : ",
      warning: "{n} secteur en avertissement : | {n} secteurs en avertissement : ",
      bothSuffix: "(+ {n} en avertissement)",
    },
  },
  countdown: {
    title: "L'événement commence dans",
    days: "Jours",
    hours: "Heures",
    minutes: "Minutes",
    seconds: "Secondes",
  },
  charts: {
    detections: "Détections par {granularity} - {subtitle}",
    cumulativeDetections: "Détections cumulatives par {granularity} - {subtitle}",
    detectionsPerCamera: "Détections par caméra",
    detectionsPerTimeslot: "Détections par {granularity}",
    detectionsLabel: "détections",
    granularity: {
      minute: "Minute",
      hour: "Heure",
      day: "Jour",
      week: "Semaine",
      month: "Mois",
      year: "Année",
    },
    monthLabels: ["Janv", "Févr", "Mars", "Avr", "Mai", "Juin", "Juil", "Août", "Sept", "Oct", "Nov", "Déc"],
    weekdayLabels: ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"],
    timeLabels: {
      midnight: "12a",
      noon: "12p",
      amSuffix: "a",
      pmSuffix: "p",
    },
  },
}
